export const parseLayerData = (layer) => {
  const { LayerName, LatestMatchingVersion } = layer;
  const { Description, LayerVersionArn } = LatestMatchingVersion;

  let runtime = 'Unknown';
  let runtimeVersion = '';
  let architecture = 'x86_64';
  let extensionVersion = 'N/A';
  let agentVersion = 'N/A';
  
  if (LayerName.includes('ARM64')) {
    architecture = 'arm64';
  }

  if (LayerName.startsWith('NewRelicLambdaExtension')) {
    runtime = 'Go';
    runtimeVersion = 'Extension-Only';
  } else {
    const runtimeMatch = LayerName.match(/NewRelic(DotNet|Java|NodeJS|Python|Ruby)(\d*X?)/i);
    if (runtimeMatch) {
      const runtimeMap = { 
        'dotnet': '.NET', 
        'java': 'Java', 
        'nodejs': 'Node.js', 
        'python': 'Python', 
        'ruby': 'Ruby' 
      };
      runtime = runtimeMap[runtimeMatch[1].toLowerCase()];
      const rawVersion = runtimeMatch[2]; 

      if (runtime === '.NET') {
        // AWS uses: dotnet6, dotnet8, etc.
        if (rawVersion === '6') {
          runtimeVersion = 'dotnet6';
        } else if (rawVersion === '8') {
          runtimeVersion = 'dotnet8';
        } else {
          runtimeVersion = `dotnet${rawVersion}`;
        }
      } else if (runtime === 'Python' && rawVersion.length > 1) {
        // AWS uses: python3.9, python3.10, python3.11, etc.
        runtimeVersion = `python${rawVersion.slice(0, 1)}.${rawVersion.slice(1)}`;
      } else if (runtime === 'Ruby' && rawVersion.length > 1) {
        // AWS uses: ruby3.2, ruby3.3, ruby3.4, etc.
        runtimeVersion = `ruby${rawVersion.slice(0, 1)}.${rawVersion.slice(1)}`;
      } else if (runtime === 'Java' && rawVersion) {
        // AWS uses: java8, java11, java17, java21, etc.
        if (rawVersion === '8') {
          runtimeVersion = 'java8.al2';
        } else {
          runtimeVersion = `java${rawVersion}`;
        }
      } else if (runtime === 'Node.js' && rawVersion) {
        // AWS uses: nodejs18.x, nodejs20.x, nodejs22.x, etc.
        runtimeVersion = `nodejs${rawVersion.replace('X', '.x')}`;
      } else if (rawVersion) {
        runtimeVersion = rawVersion.replace('X', '.x');
      } else {
        runtimeVersion = 'N/A';
      }
    }
  }
  
  const extensionMatch = Description.match(/Extension v([\d.]+)/);
  if (extensionMatch) {
    extensionVersion = `v${extensionMatch[1]}`;
  }

  const agentMatch = Description.match(/(?:Node|Python|Java|Ruby|DotNet) Agent v([\d.]+)/i);
  if (agentMatch) {
    agentVersion = `v${agentMatch[1]}`;
  }

  return {
    id: LayerVersionArn,
    runtime,
    runtimeVersion,
    architecture,
    extensionVersion,
    agentVersion,
    arn: LayerVersionArn,
  };
};

// Get color-coded badge class for runtime versions
export const getRuntimeBadgeClass = (runtime, runtimeVersion) => {
  const baseClass = 'runtime-badge';
  
  if (runtime === 'Python') {
    return `${baseClass} runtime-badge-python`;
  } else if (runtime === 'Node.js') {
    return `${baseClass} runtime-badge-nodejs`;
  } else if (runtime === 'Java') {
    return `${baseClass} runtime-badge-java`;
  } else if (runtime === 'Ruby') {
    return `${baseClass} runtime-badge-ruby`;
  } else if (runtime === 'Go') {
    return `${baseClass} runtime-badge-go`;
  } else if (runtime === '.NET') {
    return `${baseClass} runtime-badge-dotnet`;
  }
  
  return baseClass;
};
